<form class="flex flex-col"
      (click)="$event.stopPropagation()"
      [formGroup]="filterState">
  <div class="flex flex-col py-2 px-4">
    <span>Time period since</span>
    <mat-chip-set aria-label="Quick date-time selection">
      @for (dateTime of quickDateTimeArr; track dateTime) {
        <mat-chip (click)="onQuickDateTimeClick(dateTime)">{{ dateTime }}</mat-chip>
      }
    </mat-chip-set>
  </div>

  <mat-divider></mat-divider>

  <div class="flex flex-col py-2 px-4">
    <span class="mb-1">Start time</span>

    <div class="flex">
      <mat-form-field class="mr-2 max-w-[160px]">
        <input matInput
               [max]="this.now?.toISOString()"
               placeholder="DD/MM/YYYY"
               appGxInput
               [matDatepicker]="fromDatePicker"
               formControlName="fromDate">
        @if (!filterState.valid) {
          <mat-error>{{ getErrorKey(filterState.get('fromDate')) | translate }}</mat-error>
        }
        <mat-datepicker #fromDatePicker/>
        <mat-datepicker-toggle [for]="fromDatePicker"
                               matIconSuffix
                               (click)="$event.stopPropagation()"/>
      </mat-form-field>

      <mat-form-field class="max-w-[120px]">
        <input matInput
               [matTimepickerMax]="getTimepickerMax()"
               placeholder="hh:mm"
               appGxInput
               [matTimepicker]="fromTimePicker"
               formControlName="fromTime">
        @if (!filterState.valid) {
          <mat-error>{{ getErrorKey(filterState.get('fromTime')) | translate }}</mat-error>
        }
        <mat-timepicker #fromTimePicker/>
        <mat-timepicker-toggle [for]="fromTimePicker"
                               matIconSuffix
                               (click)="$event.stopPropagation()"/>
      </mat-form-field>
    </div>

    <div class="flex justify-end">
      <button mat-button
              (click)="getLocationsWithUpdates()"
              [disabled]="filterState.invalid">Apply</button>
    </div>
  </div>
</form>
